export default __webpack_public_path__ + "74ae33ac1829441d334b7880ffda08db.png";